/* import __COLOCATED_TEMPLATE__ from './simple-table.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnly from '@ember/component/template-only';

interface Args {
  label: string;
  data?: any[];
  columns: any[];
  totalPrice: number;
}

interface Signature {
  Args: Args;
}

const SimpleTable = templateOnly<Signature>();

export default SimpleTable;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Usage::Phone::SimpleTable': typeof SimpleTable;
    'billing/usage/phone/simple-table': typeof SimpleTable;
  }
}
